<template>
  <div>
    <v-chip
      close
      close-icon="mdi-close"
      @click:close="toggleCandidate(candidateId)"
      label
      class="cChip mr-2 mb-2"
      :key="candidateId"
      v-for="candidateId in filteredSelectedCandidates"
    >
      <span class="d-inline-block text-truncate">{{ getById(candidateId).firstName }} {{ getById(candidateId).lastName }}</span>
    </v-chip>
    <v-chip
      v-if="selectedCandidatesLength > 10"
      label
      class="cChip mr-2 mb-2"
    >
      <span class="d-inline-block text-truncate">
        {{ $t('andMore') }} {{ selectedCandidatesLength - 10 }}
      </span>
    </v-chip>
  </div>
</template>

<script>
import { useKanbanMultipleOperations } from '@/compositions/useKanbanMultipleOperations';
import useCandidates from '@/compositions/useCandidates';
import { computed } from '@vue/composition-api';

export default {
  name: 'KanbanGroupOperationsCandidates',
  setup() {
    const { selectedCandidates, toggleCandidate } = useKanbanMultipleOperations();
    const { findCandidateById } = useCandidates();

    const selectedCandidatesLength = computed(() => selectedCandidates.value?.length);
    const filteredSelectedCandidates = computed(() => (selectedCandidatesLength.value > 10
      ? selectedCandidates.value.slice(0, 10)
      : selectedCandidates.value));

    function getById(candidateId) {
      return findCandidateById(candidateId);
    }

    return {
      selectedCandidates,
      toggleCandidate,
      getById,
      selectedCandidatesLength,
      filteredSelectedCandidates,
    };
  },
};
</script>

<style scoped lang="scss">
.cChip { background-color: #e0e0e0; }
</style>

<i18n locale="ru" lang="yaml">
  selected: Выбрано
  andMore: и еще
</i18n>

<i18n locale="en" lang="yaml">
  selected: Selected
  andMore: and more
</i18n>
